const enum ENVIRONMENTS {
  LOCAL = 'LOCAL',
  DEV = 'DEV',
  INT = 'INT',
  UAT = 'UAT',
  PROD = 'PROD',
}

const ENDPOINTS_CONFIG_FILE_NAME = {
  LOCAL: 'localEndpointStub.json',
  DEV: 'devEndpointStub.json',
  INT: 'intEndpointStub.json',
  UAT: 'uatEndpointStub.json',
  PROD: 'proEndpointStub.json',
}

const ENVIRONMENT_FILE_NAME = 'envstub.json'

const COMUNNICATION_CONFIG_LANGUAGE =
  'Communication config must have a "language" with verb "get" for i18n service'

export {
  ENVIRONMENTS,
  ENVIRONMENT_FILE_NAME,
  COMUNNICATION_CONFIG_LANGUAGE,
  ENDPOINTS_CONFIG_FILE_NAME,
}
